import {
  LayoutDashboard,
  CalendarDays,
  Users,
  Bell,
  ClipboardList,
  ShieldAlert,
  Settings,
  BarChart3,
  LayoutGrid,
} from "lucide-react";
import { ADMIN_NAV, ADMIN_MODULE_LABELS } from "@/constants/testIds";
import { ADMIN_MODULES } from "@/data/adminAuthStore";

/**
 * Definición única del menú administrativo.
 * Orden explícito según especificación:
 *   Dashboard · Eventos · Usuarios · Notificaciones · Bitácora · Configuración · Reportes
 * `disabled: true` deshabilita el ítem visualmente y bloquea la navegación
 * (marca "Próximamente").
 */
export const ADMIN_MENU = [
  {
    key: ADMIN_MODULES.dashboard,
    to: "/admin",
    end: true,
    label: ADMIN_MODULE_LABELS.dashboard,
    icon: LayoutDashboard,
    testId: ADMIN_NAV.dashboard,
  },
  {
    key: ADMIN_MODULES.eventos,
    to: "/admin/eventos",
    label: ADMIN_MODULE_LABELS.eventos,
    icon: CalendarDays,
    testId: ADMIN_NAV.eventos,
  },
  {
    key: ADMIN_MODULES.plantillasMesas,
    to: "/admin/plantillas-mesas",
    label: ADMIN_MODULE_LABELS.plantillasMesas,
    icon: LayoutGrid,
    testId: ADMIN_NAV.plantillasMesas,
  },
  {
    key: ADMIN_MODULES.usuarios,
    to: "/admin/usuarios",
    label: ADMIN_MODULE_LABELS.usuarios,
    icon: Users,
    testId: ADMIN_NAV.usuarios,
  },
  {
    key: ADMIN_MODULES.notificaciones,
    to: "/admin/notificaciones",
    label: ADMIN_MODULE_LABELS.notificaciones,
    icon: Bell,
    testId: ADMIN_NAV.notificaciones,
  },
  {
    key: ADMIN_MODULES.bitacora,
    to: "/admin/bitacora",
    label: ADMIN_MODULE_LABELS.bitacora,
    icon: ClipboardList,
    testId: ADMIN_NAV.bitacora,
  },
  {
    key: "bloqueos",
    to: "/admin/bloqueos",
    label: "Bloqueos",
    icon: ShieldAlert,
    testId: "admin-nav-bloqueos",
  },
  {
    key: ADMIN_MODULES.configuracion,
    to: "/admin/configuracion",
    label: ADMIN_MODULE_LABELS.configuracion,
    icon: Settings,
    testId: ADMIN_NAV.configuracion,
  },
  {
    key: ADMIN_MODULES.reportes,
    to: "/admin/reportes",
    label: ADMIN_MODULE_LABELS.reportes,
    icon: BarChart3,
    testId: ADMIN_NAV.reportes,
    disabled: true,
    disabledLabel: "Próximamente",
  },
];

/** Devuelve la etiqueta de la pantalla activa según pathname. */
export const getActiveModuleLabel = (pathname) => {
  const normalized = (pathname || "").replace(/\/+$/, "");
  const exact = ADMIN_MENU.find(
    (m) => m.to.replace(/\/+$/, "") === normalized,
  );
  if (exact) return exact.label;
  const prefix = ADMIN_MENU.filter((m) => m.to !== "/admin").find((m) =>
    normalized.startsWith(m.to),
  );
  if (prefix) return prefix.label;
  return ADMIN_MODULE_LABELS.dashboard;
};
